import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: ${COLORS.LightBackground2};
`;